import { createBooleanTagManager } from '../../utils/createBooleanTagManager';

export const demolishedInMoscowProgramTagManager = createBooleanTagManager({
  jsonQueryKey: 'demolished_in_moscow_programm',
  trueLabel: 'Только дома под снос',
  falseLabel: 'Не показывать дома под снос',
  id: 'demolishedInMoscowProgram',
});
